import React, { useEffect, useMemo } from "react";

const COLORS = ["#0d9488", "#f59e0b", "#f43f5e", "#6366f1", "#10b981", "#facc15", "#38bdf8"];

export const playCheerSound = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const play = () => {
      const notes = [523.25, 659.25, 783.99, 1046.5];
      notes.forEach((f, i) => {
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = "triangle";
        o.frequency.value = f;
        const t = ctx.currentTime + i * 0.12;
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
        o.connect(g).connect(ctx.destination);
        o.start(t);
        o.stop(t + 0.4);
      });
      setTimeout(() => ctx.close().catch(() => {}), 1500);
    };
    if (ctx.state === "suspended") {
      const resume = () => { ctx.resume().then(play); window.removeEventListener("pointerdown", resume); };
      window.addEventListener("pointerdown", resume, { once: true });
    } else {
      play();
    }
  } catch (e) { /* audio tidak tersedia */ }
};

export const Confetti = ({ count = 60, duration = 2800, sound = true, onDone }) => {
  const pieces = useMemo(() => Array.from({ length: count }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 0.6,
    dur: 2 + Math.random() * 1.4,
    size: 6 + Math.random() * 8,
    color: COLORS[i % COLORS.length],
    rot: Math.random() * 360,
    round: Math.random() > 0.6,
  })), [count]);

  useEffect(() => {
    if (sound) playCheerSound();
    const t = setTimeout(() => onDone?.(), duration);
    return () => clearTimeout(t);
  }, [duration, onDone, sound]);

  return (
    <div className="pointer-events-none fixed inset-0 z-[70] overflow-hidden" aria-hidden data-testid="confetti">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`, width: p.size, height: p.round ? p.size : p.size * 0.5,
            background: p.color, borderRadius: p.round ? "50%" : 2,
            animationDelay: `${p.delay}s`, animationDuration: `${p.dur}s`,
            transform: `rotate(${p.rot}deg)`,
          }}
        />
      ))}
    </div>
  );
};
